module.exports = __webpack_public_path__ + "img/info_img3.839e8817.png";